export default __webpack_public_path__ + "static/media/Wanderer-brewery-Bengaluru.88266d00.jpg";